import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

// GET /cirurgia exige dataInicial/dataFinal (não são opcionais no backend) —
// essa janela larga cobre "todo o histórico" sem precisar de um endpoint
// dedicado de contagem/perfil por médico, que ainda não existe.
const DATA_INICIAL_AMPLA = "2000-01-01";
const DATA_FINAL_AMPLA = "2100-12-31";

const contarPorMedico = async (medicoId: string): Promise<number> => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { medicoId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, size: 1 },
  });
  return result?.data?.totalElements ?? 0;
};

const listarProximasPorMedico = async (medicoId: string, limite = 5) => {
  const hoje = new Date().toISOString().slice(0, 10);
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { medicoId, status: "AGENDADA", dataInicial: hoje, dataFinal: DATA_FINAL_AMPLA, ordem: "asc", size: limite },
  });
  return result?.data?.content ?? [];
};

const listarTodasPorMedico = async (medicoId: string, limite = 50) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { medicoId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, ordem: "desc", size: limite },
  });
  return result?.data?.content ?? [];
};

const contarPorPaciente = async (pacienteId: string): Promise<number> => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { pacienteId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, size: 1 },
  });
  return result?.data?.totalElements ?? 0;
};

const listarProximasPorPaciente = async (pacienteId: string, limite = 5) => {
  const hoje = new Date().toISOString().slice(0, 10);
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { pacienteId, status: "AGENDADA", dataInicial: hoje, dataFinal: DATA_FINAL_AMPLA, ordem: "asc", size: limite },
  });
  return result?.data?.content ?? [];
};

const listarTodasPorPaciente = async (pacienteId: string, limite = 50) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { pacienteId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, ordem: "desc", size: limite },
  });
  return result?.data?.content ?? [];
};

const contarPorInstrumentador = async (instrumentadorId: string): Promise<number> => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { instrumentadorId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, size: 1 },
  });
  return result?.data?.totalElements ?? 0;
};

const listarProximasPorInstrumentador = async (instrumentadorId: string, limite = 5) => {
  const hoje = new Date().toISOString().slice(0, 10);
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { instrumentadorId, status: "AGENDADA", dataInicial: hoje, dataFinal: DATA_FINAL_AMPLA, ordem: "asc", size: limite },
  });
  return result?.data?.content ?? [];
};

const listarTodasPorInstrumentador = async (instrumentadorId: string, limite = 50) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/cirurgia",
    params: { instrumentadorId, dataInicial: DATA_INICIAL_AMPLA, dataFinal: DATA_FINAL_AMPLA, ordem: "desc", size: limite },
  });
  return result?.data?.content ?? [];
};

const cirurgiaService = {
  contarPorMedico, listarProximasPorMedico, listarTodasPorMedico,
  contarPorPaciente, listarProximasPorPaciente, listarTodasPorPaciente,
  contarPorInstrumentador, listarProximasPorInstrumentador, listarTodasPorInstrumentador,
};
export default cirurgiaService;
